export interface AppSettings {
  dir: 'ltr' | 'rtl';
  headerPos: 'fixed' | 'static' | 'above';
  language: string;
  navPos: 'side' | 'top';
  showHeader: boolean;
  sidenavCollapsed: boolean;
  sidenavOpened: boolean;
  theme: THEME;
}

export const enum THEME {
  LIGHT = 'light',
  DARK = 'dark',
}

export const defaults: AppSettings = {
  navPos: 'top',
  dir: 'ltr',
  theme: THEME.LIGHT,
  showHeader: true,
  headerPos: 'fixed',
  sidenavOpened: false,
  sidenavCollapsed: false,
  language: 'en-US',
};
